const SCRIPT_ID = "google-recaptcha-v3-script";
const RECAPTCHA_SRC = "https://www.google.com/recaptcha/api.js?render=";

let loadPromise;

const getSiteKey = () => process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const assertSiteKey = () => {
  const siteKey = getSiteKey();
  if (!siteKey) {
    throw new Error("reCAPTCHA site key is not configured");
  }
  return siteKey;
};

const loadScript = (siteKey) => {
  if (loadPromise) {
    return loadPromise;
  }

  const existingScript = document.getElementById(SCRIPT_ID);
  if (existingScript) {
    loadPromise = Promise.resolve();
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = `${RECAPTCHA_SRC}${encodeURIComponent(siteKey)}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load reCAPTCHA"));
    document.head.appendChild(script);
  });

  return loadPromise;
};

export const executeRecaptcha = async (action) => {
  const siteKey = assertSiteKey();

  if (!action) {
    throw new Error("reCAPTCHA action is required");
  }

  await loadScript(siteKey);

  if (!window.grecaptcha) {
    throw new Error("reCAPTCHA is not available");
  }

  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(siteKey, { action })
        .then(resolve)
        .catch(() => reject(new Error("Failed to execute reCAPTCHA")));
    });
  });
};

export const preloadRecaptcha = async () => {
  const siteKey = assertSiteKey();
  await loadScript(siteKey);
};

